<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <b-overlay
      :show="loading"
      rounded="sm"
      :variant="$store.state.appConfig.layout.skin === 'dark' ? 'dark' : 'light'"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <!-- Search -->
          <b-col cols="12" lg="4">
            <div class="d-flex align-items-center justify-content-end mb-1 mb-lg-0">
              <b-form-input v-model="searchQuery" class="d-inline-block w-100" placeholder="Buscar..."/>
            </div>
          </b-col>

          <!-- Type Filter and Status Filter -->
          <b-col
            cols="12"
            md="6"
            lg="4"
            class="d-flex align-items-center justify-content-center mb-1 mb-lg-0"
          >
            <v-select v-model="typeFilter" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="typeOptions" label="text" :reduce="v => v.value" class="w-100 d-inline-block mr-2" placeholder="Seleccionar Tipo"/>
            <v-select v-model="statusFilter" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="statusOptions" label="text" :reduce="v => v.value" class="w-100 d-inline-block"/>
          </b-col>

          <!-- Per Page -->
          <b-col
            cols="6"
            md="3"
            lg="2"
            class="d-flex align-items-center justify-content-between mb-1 mb-lg-0"
          >
            <label>Items</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="w-100 d-inline-block ml-1"
            />
          </b-col>

          <!-- Export -->
          <b-col
            cols="6"
            md="3"
            lg="2"
            class="mb-1 mb-lg-0"
          >
            <b-button
              variant="outline-primary"
              class="w-100 d-inline-block"
              @click="dialogExport = true"
            >
              Exportar
            </b-button>
          </b-col>
        </b-row>

      </div>

      <b-modal
        v-model="dialog"
        title="Datos de Alerta"
        hide-footer
      >
        <details-data
          :item.sync="editedItem"
          :loading.sync="loading"
          @close="close"
          @save="deactivate"
        />
      </b-modal>

      <b-modal
        v-model="dialogDeactivate"
        title="Desactivar Alerta"
        hide-footer
      >
        <deactivate-alert
          :loading.sync="loading"
          @close="close"
          @delete="deactivate"
        />
      </b-modal>

      <b-modal
        v-model="dialogExport"
        title="Exportar datos"
        hide-footer
      >
        <export-data
          :loading.sync="loading"
          @close="close"
          @export="exportData"
        />
      </b-modal>

      <b-table
        ref="refDataTable"
        :items="fetchData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No hay datos disponibles."
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        :loading="loading"
        loading-text="Cargando..."
      >

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="data.item.status === 'active' ? 'light-danger' : 'light-success'"
          >
            {{ data.item.status === 'active' ? 'Activa' : 'No Activa' }}
          </b-badge>
        </template>

        <!-- Column: createdAt -->
        <template #cell(createdAt)="data">
          <span class="text-capitalize">{{ $moment(data.value).format('DD/MM/YYYY HH:mm:ss') }}</span>
        </template>

        <!-- Column: updatedAt -->
        <template #cell(updatedAt)="data">
          <span class="text-capitalize">{{ data.item.status === 'inactive' ? $moment(data.value).format('DD/MM/YYYY HH:mm:ss') : '--' }}</span>
        </template>

        <!-- Column: Alert -->
        <template #cell(alert)="data">
          <b-link
            class="font-weight-bold"
            @click="editItem(data.item)"
          >
            {{ data.value }}
          </b-link>
        </template>

        <!-- Column: ValueAlert-->
        <template #cell(valueAlert)="data">
          <b-badge
            pill
            variant="light-danger"
          >
 
            {{ data.item.typeAlert === 'status'
              ? $moment.utc(data.value).local().format('DD/MM/YYYY hh:mm:ss a')
              : data.item.valueAlert
            }}
          </b-badge>
          {{ data.item.typeAlert != 'status' && data.item.typeAlert != 'boolean' ? data.item.operator + ' ' + data.item.valueThreshold : '' }}
        </template>

        <!-- Column: Process -->
        <template #cell(process)="data">
          <span class="text-capitalize">{{ data.value }}</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex align-items-center justify-content-center text-nowrap">
            <feather-icon
              :id="`alert-history-row-${data.item.id}-edit-icon`"
              icon="FileTextIcon"
              class="cursor-pointer mr-1"
              size="16"
              @click="editItem(data.item)"
            />
            <b-tooltip
              title="Detalles"
              class="cursor-pointer"
              :target="`alert-history-row-${data.item.id}-edit-icon`"
            />

            <feather-icon
              v-if="data.item.typeAlert === 'flow' && data.item.status === 'active'"
              :id="`alert-history-row-${data.item.id}-trash-icon`"
              icon="BellOffIcon"
              class="cursor-pointer"
              size="16"
              @click="deleteItem(data.item)"
            />
            <b-tooltip
              v-if="data.item.typeAlert === 'flow' && data.item.status === 'active'"
              title="Desactivar"
              class="cursor-pointer"
              :target="`alert-history-row-${data.item.id}-trash-icon`"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} items</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

      <template #overlay>
        <!-- Show loading spinner if loading -->
        <loading-logo
          v-if="loading"
          class="mt-4 mb-4"
        />
      </template>
    </b-overlay>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BPagination, BTooltip, BBadge, BOverlay, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import DeactivateAlert from '@/views/utils/DeactivateAlert.vue'
import ExportData from '@/views/utils/ExportData.vue'
import exportFromJSON from 'export-from-json'
import alertHistoryStoreModule from './alertHistoryStoreModule'
import allFetchData from './allFetchData'
import DetailsData from './DetailsData.vue'
import LoadingLogo from '../../miscellaneous/LoadingLogo.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BTooltip,
    BBadge,
    vSelect,
    DetailsData,
    DeactivateAlert,
    LoadingLogo,
    BOverlay,
    ExportData,
    BLink,
  },
  setup() {
    const ALERT_HISTORY_APP_STORE_MODULE_NAME = 'alertHistory'

    // Register module
    if (!store.hasModule(ALERT_HISTORY_APP_STORE_MODULE_NAME)) store.registerModule(ALERT_HISTORY_APP_STORE_MODULE_NAME, alertHistoryStoreModule)

    const {
      fetchData,
      fetchUpdate,
      fetchExport,
      fetchCountAlertActive,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      statusFilter,
      typeFilter,
      refetchData,
    } = allFetchData()

    return {
      fetchData,
      fetchUpdate,
      fetchExport,
      fetchCountAlertActive,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataTable,
      loading,
      statusFilter,
      typeFilter,
      refetchData,
    }
  },
  data() {
    return {
      statusOptions: [
        { value: 'all', text: 'Todas' },
        { value: 'active', text: 'Activa' },
        { value: 'inactive', text: 'No Activa' },
      ],
      typeOptions: [
        { value: 'all', text: 'Todas' },
        { value: 'status', text: 'Estado' },
        { value: 'users', text: 'Usuario' },
      ],
      dialog: false,
      dialogDeactivate: false,
      dialogExport: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        status: '',
      },
    }
  },
  created() {
    const type = this.$route.query.type;
    if (type) {

      this.typeFilter = type;
    }
  },
  computed: {
    countAlertActive() {
      return this.$store.state.alertHistory.countAlertActive
    },
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close()
    },
  },
  methods: {
    deactivate() {
      this.fetchUpdate(this.editedItem.id, () => {
        this.$store.commit('alertHistory/SET_COUNT_ALERT_ACTIVE', (this.countAlertActive - 1))
        this.close()
      })
    },
    editItem(item) {
      this.editedItem = { ...item }
      this.dialog = true
    },
    deleteItem(item) {
      this.editedItem = { ...item }
      this.dialogDeactivate = true
    },
    close() {
      this.dialog = false
      this.dialogExport = false
      this.dialogDeactivate = false
      this.$nextTick(() => {
        this.editedItem = { }
      })
    },
    exportData() {
      this.fetchExport(this.editedItem, res => {
        try {
          const fileName = 'Listado de Alertas'
          const exportType = exportFromJSON.types.xls
          const data = res.map(item => ({
            fecha_activacion: this.$moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
            fecha_desactivacion: item.status === 'inactive' ? this.$moment(item.updateAt).format('DD/MM/YYYY HH:mm:ss') : '',
            estado: this.statusOptions.find(option => option.value === item.status).text,
            alerta: item.alert,
            sector: item.site,
            pila: item.stack,
            proceso: item.process,
            dispositivo: item.device,
            valor_alerta: item.typeAlert === 'flow' ? item.valueAlert : this.$moment(item.valueAlert).format('DD/MM/YYYY HH:mm:ss'),
            valor_umbral: item.typeAlert === 'flow' ? `${item.operator} ${item.valueThreshold}` : '',
          }))
          if (data) exportFromJSON({ data, fileName, exportType })
        } catch (error) {
          console.log('error', error)
        }
        this.close()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.status-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
